import { StyledConfigRow } from '../InsightsConfig.style';
import InsightSwitch from '../Inputs/InsightSwitch';
import InputNumber from 'components/base/InputNumber';
import { useContext } from 'react';
import InsightsFormStateContext from '../useFormState/form.state.context';
import { INSIGHTS_KEYS } from '../../../insights.keys';
import usePmViewer from 'common/hooks/pm/usePmViewer';

const ContextSwitch = () => {
  const { getInsight, updateInsight, onToggleSwitch } = useContext(
    InsightsFormStateContext
  );
  const pmViewer = usePmViewer();
  const parentOneText = pmViewer.oldIssueParent1.plural;

  const insight = getInsight(INSIGHTS_KEYS.CONTEXT_SWITCH);

  return (
    <StyledConfigRow>
      <InsightSwitch insight={insight} onClick={onToggleSwitch} />
      A developer is assigned to
      <InputNumber
        value={insight.epics}
        onChange={value =>
          updateInsight(insight.key, {
            epics: value
          })
        }
      />
      {parentOneText} or more
    </StyledConfigRow>
  );
};

export default ContextSwitch;
